// utils/subscriptionUtils.js
export const checkPropertyUploadLimit = async (userId, userType, propertyType) => {
  try {
    // Get user subscriptions from the new endpoint
    const subResponse = await fetch(`https://landnest.net:81/Get-user-plan/${userId}/`);
    
    if (!subResponse.ok) {
      return { canUpload: false, message: 'Please subscribe to upload properties' };
    }

    const subscriptions = await subResponse.json();

    // Filter subscriptions matching either the userType or Agent (for Individual Owner/Builder)
    const validSubscriptions = Array.isArray(subscriptions) 
      ? subscriptions.filter(sub => 
          sub.user_type === userType || 
          (userType === 'Individual Owner/Builder' && sub.user_type === 'Agent')
        )
      : [];

    if (validSubscriptions.length === 0) {
      return { 
        canUpload: false, 
        message: `No ${userType} or Agent subscription found. Please subscribe.`
      };
    }

    // Get all properties
    const propResponse = await fetch('https://landnest.net:81/property/');
    const propData = await propResponse.json();
    
    // Filter properties based on user type and property type groups
    let userProperties;
    if (userType === 'Landlord') {
      // For Landlord: count both rent and lease properties
      userProperties = propData.filter(prop => 
        prop.user_id === userId && 
        (prop.type === 'rent' || prop.type === 'lease')
      );
    } else {
      // For Individual Owner/Builder and Agent: count both sell and best-deal properties
      userProperties = propData.filter(prop => 
        prop.user_id === userId && 
        (prop.type === 'sell' || prop.type === 'best-deal')
      );
    }

    // Calculate combined limits from all applicable subscriptions
    let totalAllowed = 0;
    let hasUnlimited = false;

    validSubscriptions.forEach(sub => {
      if (sub.no_of_properties_unlimited) {
        hasUnlimited = true;
      } else {
        totalAllowed += sub.no_of_properties || 0; // Handle potential undefined values
      }
    });

    // Check if unlimited properties allowed from any subscription
    if (hasUnlimited) {
      return { canUpload: true };
    }

    // Check remaining uploads for this property type group
    const remainingUploads = totalAllowed - userProperties.length;
    
    if (remainingUploads <= 0) {
      const typeGroup = userType === 'Landlord' ? 'rent/lease' : 'sell/best-deal';
      return { 
        canUpload: false, 
        message: `You've reached your combined upload limit for ${typeGroup} properties (${totalAllowed}). Please upgrade your plan.`
      };
    }

    const typeGroup = userType === 'Landlord' ? 'rent/lease' : 'sell/best-deal';
    return { 
      canUpload: true, 
      remaining: remainingUploads,
      message: `You can upload ${remainingUploads} more ${typeGroup} properties with your combined plans.`
    };

  } catch (error) {
    console.error('Error checking upload limit:', error);
    return { canUpload: false, message: 'Error checking your upload limit. Please try again.' };
  }
};


// Below code was Without Sum of Agent and Individual Owner/Builder subscriptions

// export const checkPropertyUploadLimit = async (userId, userType, propertyType) => {
//   try {
//     // Get all user subscriptions
//     const subResponse = await fetch(`https://landnest.net:81/Get-all-plan/${userId}/`);
    
//     if (!subResponse.ok) {
//       return { canUpload: false, message: 'Please subscribe to upload properties' };
//     }

//     const subscriptions = await subResponse.json();

//     // Filter active subscriptions matching the user_type
//     const activeSubscriptions = Array.isArray(subscriptions) 
//       ? subscriptions.filter(sub => 
//           sub.status && 
//           new Date(sub.expired_date) > new Date() &&
//           sub.user_type === userType
//         )
//       : [];

//     if (activeSubscriptions.length === 0) {
//       return { 
//         canUpload: false, 
//         message: `No active ${userType} subscription found. Please subscribe.`
//       };
//     }

//     // Get all properties
//     const propResponse = await fetch('https://landnest.net:81/property/');
//     const propData = await propResponse.json();
    
//     // Filter properties based on user type and property type groups
//     let userProperties;
//     if (userType === 'Landlord') {
//       // For Landlord: count both rent and lease properties
//       userProperties = propData.filter(prop => 
//         prop.user_id === userId && 
//         (prop.type === 'rent' || prop.type === 'lease')
//       );
//     } else if (userType === 'Individual Owner/Builder') {
//       // For Individual Owner/Builder: count both sell and best-deal properties
//       userProperties = propData.filter(prop => 
//         prop.user_id === userId && 
//         (prop.type === 'sell' || prop.type === 'best-deal')
//       );
//     } else {
//       // For other user types, use exact type match
//       userProperties = propData.filter(prop => 
//         prop.user_id === userId && 
//         prop.type === propertyType
//       );
//     }

//     // Find the subscription with highest property limit
//     const bestSubscription = activeSubscriptions.reduce((prev, current) => {
//       // Prefer unlimited if available
//       if (current.no_of_properties_unlimited) return current;
//       if (prev.no_of_properties_unlimited) return prev;
//       // Otherwise take the one with higher limit
//       return (current.no_of_properties > prev.no_of_properties) ? current : prev;
//     });

//     // Check if unlimited properties allowed
//     if (bestSubscription.no_of_properties_unlimited) {
//       return { canUpload: true };
//     }

//     // Check remaining uploads for this property type group
//     const remainingUploads = bestSubscription.no_of_properties - userProperties.length;
    
//     if (remainingUploads <= 0) {
//       const typeGroup = userType === 'Landlord' ? 'rent/lease' : 'sell/best-deal';
//       return { 
//         canUpload: false, 
//         message: `You've reached your ${userType} upload limit for ${typeGroup} properties (${bestSubscription.no_of_properties}). Please upgrade your plan.`
//       };
//     }

//     const typeGroup = userType === 'Landlord' ? 'rent/lease' : 'sell/best-deal';
//     return { 
//       canUpload: true, 
//       remaining: remainingUploads,
//       message: `You can upload ${remainingUploads} more ${typeGroup} properties with your ${userType} plan.`
//     };

//   } catch (error) {
//     console.error('Error checking upload limit:', error);
//     return { canUpload: false, message: 'Error checking your upload limit. Please try again.' };
//   }
// };